import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import CustomSelect from "../common/CustomSelect";
import RangeSlider from "../common/RangeSlider";

export const DynamicFilter = ({
    filters,
    selectedFilterProps,
    handleFilterChange,
}) => {
    const [selectedFilters, updateSelectedFilters] = useState({});

    useEffect(() => {
        updateSelectedFilters(selectedFilterProps);
    }, [selectedFilterProps]);


    return (
        <Box sx={styles.filterContainer}>
            {filters?.map((filter) =>
                filter.type === "range-slider" ? (
                    <RangeSlider
                        key={filter.key}
                        label={filter?.label}
                        min={filter?.defaultFilterRange?.[0]}
                        max={filter?.defaultFilterRange?.[1]}
                        range={
                            selectedFilters[filter.key] ||
                            filter.defaultFilterRange
                        }
                        valueChange={(value) =>
                            handleFilterChange(filter?.key, value)
                        }
                    />
                ) : (
                    <Box key={filter.key} sx={styles.filterBox}>
                        <CustomSelect
                            filter={filter}
                            selectedValue={
                                selectedFilters[filter.key] ||
                                (filter.multiSelect ? [] : "")
                            }
                            onFilterChange={(value) =>
                                handleFilterChange(filter.key, value)
                            }
                        />
                    </Box>
                )
            )}
        </Box>
    );
};

const styles = {
    filterContainer: {
        padding: "25px 0",
    },

    filterHeader: {
        color: "#C43A29",
        // mb: 2,
    },
    filterBox: {
        display: "flex",
        flexDirection: "column",
        marginBottom: "10px",
    },
};

DynamicFilter.propTypes = {
    filters: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            options: PropTypes.arrayOf(PropTypes.string).isRequired,
            multiSelect: PropTypes.bool,
        })
    ).isRequired,
    selectedFilterProps: PropTypes.object.isRequired,
    handleFilterChange: PropTypes.func.isRequired,
};

export default DynamicFilter;
